module.exports = __webpack_public_path__ + "static/media/linecare_sc.9ac516e0.png";